import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/socials/default/behance.svg")